import { API_BASE_URL } from '../config';

export interface ContaAzulAuth {
  isValid: boolean;
  expiresAt: string | null;
  lastUpdated: string | null;
  status: string;
}

export interface SyncLogEntry {
  id: string;
  jobType: string;
  startedAt: string;
  finishedAt: string | null;
  status: string;
  salesFound: number;
  cardsCreated: number;
  cardsUpdated: number;
  cardsSkipped: number;
  errors: number;
  errorDetails: string | null;
}

export interface ContaAzulStatus {
  enabled: boolean;
  contaAzulAuth: ContaAzulAuth;
  trelloConfigured: boolean;
  lastIncrementalSync: string;
  lastReconciliationSync: string;
  oauthAuthorizedAt: string | null;
  daysSinceAuth: number | null;
  daysUntilReauth: number | null;
  runningJobs: number;
  recentSyncs: SyncLogEntry[];
}

/**
 * These endpoints are public (no auth required), but we use the
 * same fetch pattern for consistency.
 */
export async function fetchContaAzulStatus(): Promise<ContaAzulStatus> {
  const res = await fetch(`${API_BASE_URL}/integrations/contaazul-trello/status`);
  if (!res.ok) throw new Error(`${res.status}: ${res.statusText}`);
  const json = await res.json();
  return json.data ?? json;
}

export async function triggerIncrementalSync(): Promise<SyncLogEntry> {
  const res = await fetch(`${API_BASE_URL}/integrations/contaazul-trello/sync/incremental`, {
    method: 'POST',
  });
  if (!res.ok) {
    const json = await res.json().catch(() => ({}));
    throw new Error(json.error || `${res.status}: ${res.statusText}`);
  }
  const json = await res.json();
  return json.data ?? json;
}

export async function triggerReconciliationSync(): Promise<SyncLogEntry> {
  const res = await fetch(`${API_BASE_URL}/integrations/contaazul-trello/sync/reconciliation`, {
    method: 'POST',
  });
  if (!res.ok) {
    const json = await res.json().catch(() => ({}));
    throw new Error(json.error || `${res.status}: ${res.statusText}`);
  }
  const json = await res.json();
  return json.data ?? json;
}

export function getOAuthAuthorizeUrl(): string {
  return `${API_BASE_URL}/integrations/contaazul/oauth/authorize`;
}
